<style lang="less" scoped>
@import url('./index.less');
</style>

<template>
<div class="live-scroll">
  <div class="experts-question-wrap">
    <div class="dropdown-wrap">
      <van-dropdown-menu active-color="#FE7922" :style="{height:'40px'}">
        <van-dropdown-item @change="changeDiseaseHandle" v-model="value1" :options="parent.parentTabSelect.liveVideoFields" />
        <van-dropdown-item @change="changeTagHandle" v-model="value2" :options="option2" />
      </van-dropdown-menu>
    </div>
    <div class="experts-question-list-container">
      <div class="live_list_wrap" v-for="(item,index) in list" :key="index" @click="clickhandle(item)">
        <LiveCell :dataItem="item" />
      </div>
    </div>
  </div>
  <div class="empty" v-if="list.length === 0">
    <Empty />
  </div>
</div>
</template>

<script>
import { DropdownMenu, DropdownItem,Toast } from 'vant';
import LiveCell from '@/components/LiveCell'
import { HttpRequest} from 'utils/'
import { debounce, statisticalHandle } from 'utils/baseMethods.js'
export default {
  data() {
    return {
      value1: '',
      value2: '1',
      option1: [
        { text: '全部疾病', value: '' },
        { text: '肿瘤', value: '肿瘤' },
        { text: '慢性疾病', value: '慢性疾病' },
        { text: '其他', value: '其他' }
      ],
      option2: [
        { text: '全部直播', value: '' },
        { text: '未结束', value: '1' },
        { text: '已结束', value: '2' }
      ],
      list: [],
      sum:0,
      page:1
    }
  },
  components:{
    LiveCell,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  inject:['parent'],
  created() {
    this.getListData()
    this.$nextTick(()=>{
      console.log(this.$el)
      this.$el.onscroll = debounce(()=>{
        const scrollHeight = this.$el.scrollHeight
        const scrollTop = this.$el.scrollTop
        const clientHeight = this.$el.clientHeight
        if(scrollHeight - (clientHeight + scrollTop) <= 50 ){
          if (this.sum !== this.list.length) {
            this.page += 1
            this.getListData()
          }
        }
      },100)
    })
  },
  methods:{
    async getListData() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      });
      const res = await HttpRequest({
        url:'/professional/live_videos/',
        params:{
          page:this.page,
          field_level1:this.value1,
          status:this.value2
        }
      })
      Toast.clear()
      this.sum = res.count
      if(res.results.length) {
        this.list = [
          ... this.list,
          ... res.results
        ]
      }
    },
    changeDiseaseHandle(value) {
      console.log(value)
      this.page = 1
      this.list = []
      this.getListData()
    },
    changeTagHandle(value) {
      console.log(value)
      this.page = 1
      this.list = []
      this.getListData()
    },
    clickhandle(item) {
      sessionStorage.setItem('keep_active',this.parent.$data.active);//缓存tab页码
      statisticalHandle(item)
      window.location.href = item.url
    }
  }
}
</script>